import { combineReducers } from 'redux';
import { ACTIVE_AD_CAMPAIGNS } from 'Constants/adCampaigns';

const error = (state = null, action) => {
  switch (action.type) {
    case 'AD_TRACK_FAILURE':
      return action.error;
    case 'AD_CLICKED':
    case 'AD_VIEWED':
    case 'AD_TRACK_REQUEST':
      return null;
    default:
      return state;
  }
};

const adSlots = (state = {}, action) => {
  const { type, adUnitPath } = action;
  switch (type) {
    case 'AD_SLOT_LOAD':
      return {
        ...state,
        [adUnitPath]: {
          rendered: false,
        },
      };
    case 'AD_SLOT_RENDERED':
      return {
        ...state,
        [adUnitPath]: {
          ...state[adUnitPath],
          rendered: true,
        },
      };
    case 'AD_SLOT_DESTROYED':
      const destroyedState = {
        ...state,
      };
      delete destroyedState[adUnitPath];
      return destroyedState;
    default:
      return state;
  }
};

const videoPlayer = (
  state = {
    playerId: 0,
  },
  action
) => {
  switch (action.type) {
    case 'NEW_VIDEO_PLAYER_ID':
      return {
        playerId: state.playerId + 1,
      };
    default:
      return state;
  }
};

const ads = combineReducers({
  adSlots,
  videoPlayer,
  error,
});
export default ads;

export const getAdCampaign = (state, page) => ACTIVE_AD_CAMPAIGNS[page];
export const getBackgroundSkin = (state, route) => {
  const skin = ACTIVE_AD_CAMPAIGNS['backgroundSkin'];
  if (!skin) return null;
  return skin.routes.includes(route) ? skin : null;
};
export const getVisibleAdSlotCount = state => Object.keys(state.adSlots).length;
export const getRenderedAdSlotCount = state => {
  const renderedSlots = [];
  Object.keys(state.adSlots).map(id => {
    if (state.adSlots[id].rendered) renderedSlots.push(state.adSlots[id]);
  });
  return renderedSlots.length;
};
export const getVideoPlayerId = state => state.videoPlayer.playerId;
